<template>
  <div class="error">
    <svg
      class="min-h-screen min-w-screen fixed left-0"
      preserveAspectRatio="none"
      version="1.1"
      viewBox="0 0 960 540"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect fill="var(--surface-ground)" height="540px" width="960px" x="0" y="0"></rect>
      <path
        d="M0 331L26.7 321C53.3 311 106.7 291 160 291C213.3 291 266.7 311 320 329.5C373.3 348 426.7 365 480 373.2C533.3 381.3 586.7 380.7 640 373.8C693.3 367 746.7 354 800 341.2C853.3 328.3 906.7 315.7 933.3 309.3L960 303L960 541L933.3 541C906.7 541 853.3 541 800 541C746.7 541 693.3 541 640 541C586.7 541 533.3 541 480 541C426.7 541 373.3 541 320 541C266.7 541 213.3 541 160 541C106.7 541 53.3 541 26.7 541L0 541Z"
        fill="var(--primary-500)"
        stroke-linecap="round"
        stroke-linejoin="miter"
      ></path>
    </svg>

    <div class="px-5 min-h-screen flex justify-content-center align-items-center">
      <div class="z-1 text-center">
        <div class="text-900 font-bold text-8xl mb-4">{{ title }}</div>
        <p class="line-height-3 mt-0 mb-5 text-700 text-xl font-medium">{{ message }}</p>
        <div class="flex gap-2 justify-content-center">
          <Button
            class="p-button p-button-primary font-medium p-button-raised"
            outlined
            type="button"
            @click="goBack"
          >
            <span class="material-icons" style="font-size: 1.35rem">keyboard_backspace</span>
          </Button>
          <RouterLink :to="to || _to" class="">
            <Button class="p-button p-button-primary font-medium p-button-raised" type="button">
              {{ linkTitle }}
            </Button>
          </RouterLink>
        </div>
      </div>
    </div>
    <Button class="layout-config-button p-link" type="button"><i class="pi pi-cog"></i></Button>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useRouter } from "vue-router";

import Button from "primevue/button";

import { getDashboardRouterName } from "@/utilities.ts";

defineProps({
  to: {
    type: [String, Object],
    default: "",
  },
  title: {
    type: String,
    default: "Oops!",
  },
  message: {
    type: String,
    default: "There is nothing here",
  },
  linkTitle: {
    type: String,
    default: "Go to Dashboard",
  },
  showBack: {
    type: Boolean,
    default: false,
  },
});

const router = useRouter();

const _to = computed(() => ({
  name: getDashboardRouterName(),
}));

const goBack = () => {
  router.back();
};
</script>
